import { Checkbox } from '@cb/apricot-react';
import { styled } from '@mui/system';

export default styled(Checkbox)`
  & input {
    margin-right: 8px;
  }
`;
